import express from 'express';
import Locales from 'Utils/locales.js';

export const langLocale = (req: express.Request) => {
  const clientLang = req.headers['accept-language'] || 'en';
  const lang = Locales.getLanguageWithoutRegion(clientLang);
  const locale = Locales.getLocaleByLanguage(clientLang);
  return { lang, locale };
};
